<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/ship/header-img.png" />
      <div class="header-title">Partnership</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Partners" name="Partaner">
        <Partaner></Partaner>
      </el-tab-pane>
      <el-tab-pane label="Conditions Of cooperation" name="coc">
        <ConditionsOfCooperation></ConditionsOfCooperation>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ConditionsOfCooperation from "./components/ConditionsOfCooperation.vue";
import Partaner from "./components/Partaner.vue";
export default {
  components: {
    ConditionsOfCooperation,
    Partaner,
  },
  data() {
    return {
      activeName: "Partaner",
      constants: {},
    };
  },
  methods: {
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .sp-page {
    ::v-deep .el-tabs__content {
      padding: 20px 10px !important;
    }
  }
}
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
